import { render, staticRenderFns } from "./JourneyCard.vue?vue&type=template&id=3e7d18dc"
import script from "./JourneyCard.vue?vue&type=script&lang=js"
export * from "./JourneyCard.vue?vue&type=script&lang=js"
import style0 from "./JourneyCard.vue?vue&type=style&index=0&id=3e7d18dc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports